module.exports = __webpack_public_path__ + "static/media/instagram.a560780e.png";